import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE_URL } from '../config';
// Async thunk for submitting basic info

const safeIntValue = (value, defaultValue = 1) => {
    const parsedValue = parseInt(value, 10);
   if (!isNaN(parsedValue) && parsedValue >= 0) {
      return parsedValue;
    }
    return defaultValue;
  };
   

export const fetchStudentData = createAsyncThunk(
    "Student/fetchStudentData",
  async (_, { rejectWithValue }) => {

    const storedUser = localStorage.getItem("userInfo");
    if (!storedUser) {
      return rejectWithValue('No user data found');
    }

    const { token, studentIds } = JSON.parse(storedUser);
    if (!token || !studentIds || studentIds.length === 0) {
      return rejectWithValue('Token or student IDs are missing');
    }

    try {
        const studentId = studentIds[0];
         const response = await axios.get(
          `${API_BASE_URL}/api/Student/GetFullStudentInformation/${studentId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        ); 
 
        const { parents, ...studentDetails } = response.data; 
        // Destructure to get student details and parents
//       console.log("response.data", response.data);
        return {
        studentDetail: {
          ...studentDetails,
          id: studentDetails.studentId,
          firstName: studentDetails.firstName || null,
          surName: studentDetails.surName || null,
          lastName: studentDetails.lastName || null,
          email: studentDetails.email || null,
          phoneNumber: studentDetails.phoneNumber || null,
          dbo: new Date(studentDetails.dob).toLocaleDateString() || null,
          gender: safeIntValue(studentDetails.gender, 1),
          nationality: studentDetails.nationality || null,
          birthCountry: studentDetails.birthCountry || null,
          idInformationCountry: studentDetails.idInformationCountry || null,
          idNumber: studentDetails.idNumber || null,
          idCopyFile: studentDetails.idCopyFile || null,
          idCopyFileName: studentDetails.idCopyFileName || null,
          idCopyFileContentType: studentDetails.idCopyFileContentType || null,
          photo: studentDetails.photo || null,
          photoFileName: studentDetails.photoFileName || null,
          photoFileContentType: studentDetails.photoFileContentType || null,
          primaryLanguage: studentDetails.primaryLanguage || null,
          otherLanguages: studentDetails.otherLanguages || "No Data",
          religion: safeIntValue(studentDetails.religion, 1),
          gradeNumber: safeIntValue(studentDetails.gradeNumber, 1),
          birthCertificateFile: studentDetails.birthCertificateFile || null,
        },
        parentDetails: Array.isArray(parents) ? parents.map(parent => ({
          id: parent.parentId,
           firstName: parent.firstName || null,
          surName: parent.surName || null,
          lastName: parent.lastName || null,
          email: parent.email || null,
          phoneNumber: parent.phoneNumber || null,
          dob:  new Date(parent.dob).toLocaleDateString() || null,
          gender: safeIntValue(parent.gender, 1),
          nationality: parent.nationality || null,
          birthCountry: parent.birthCountry || null,
          idInformationCountry: parent.idInformationCountry || null,
          idNumber: parent.idNumber || null,
          idCopyFile: parent.idCopyFile || null,
          idCopyFileName: parent.idCopyFileName || null,
          idCopyFileContentType: parent.idCopyFileContentType || null,
          photo: parent.photo || null,
          basicInfoId: parent.basicInfoId    || null,

          photoFileName: parent.photoFileName || null,
          photoFileContentType: parent.photoFileContentType || null,

          workPlace: parent.workPlace || null,
          workPosition: parent.workPosition || null,
          address: parent.address || null,
          poBox: parent.poBox || null,
          subCity: parent.subCity || null,
          kebele: parent.kebele || null,
          houseNumber: parent.houseNumber || null,
          mobilePhone: parent.mobilePhone || null,
          homePhone: parent.homePhone || null,
          officePhone: parent.officePhone || null,
          otherPhone: parent.otherPhone || null,
          faxNumber: parent.faxNumber || null,
          preferredPhoneType: safeIntValue(parent.preferredPhoneType, 0),
          parentType: safeIntValue(parent.parentType, 1),
          occupationType: safeIntValue(parent.occupationType, 1),
          relationshipToStudent: safeIntValue(parent.relationshipToStudent, 1)
          // Add any other fields you need from the parent object
        })) : []
      };

    } catch (error) {
       return rejectWithValue(error.message);
    }
  }
);

 

const studentDataSlice = createSlice({
  name: "studentdata",
  initialState: {
    studentDetail: {},
    parentDetails: [],
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentData.pending, (state) => {
         state.loading = 'loading';
        state.error = null;
  })
      .addCase(fetchStudentData.fulfilled, (state, action) => {
        state.loading = 'succeeded';
        state.studentDetail = action.payload.studentDetail;
        state.parentDetails = action.payload.parentDetails;
  })
      .addCase(fetchStudentData.rejected, (state, action) => {
        console.error('Fetching failed:', action.error.message);
        state.loading = 'failed';
        state.error = action.error.message;
  });
  },
});


// Export the reducer
export default studentDataSlice.reducer;